/**
 * AQI Display Attribute Styles
 * 空氣品質指標顯示元件
 * 
 * Style01: Card - 卡片式佈局
 * Style02: Gauge - 圓形儀表風格
 */

import { Style01_Card } from './Style01_Card';
import { Style02_Gauge } from './Style02_Gauge';

export { Style01_Card, Style02_Gauge };

// Style registry for this attribute
export const AQIDisplayStyles = {
  Style01: Style01_Card,
  Style02: Style02_Gauge
};

// Default style
export default Style01_Card;
